module.exports = __webpack_public_path__ + "img/30.96dc9052.svg";